import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _Divider, _DownOutlined;

import { DownOutlined } from '@ant-design/icons';
import { get, identity } from 'lodash-es';
import moment from 'moment';
import React, { cloneElement, useContext, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Badge from './Badge';
import Button from './Button';
import Divider from './Divider';
import Space from './Space';
import { TmsUIContext } from '../TmsUIProvider';
import Popover from './Popover';
import translations from './translations';
var InputCard = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n"])));
var InputCardBody = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-height: 35rem;\n  overflow: auto;\n"])));
var InputCardFooter = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  justify-content: flex-end;\n"])));
export function getLabelText(_ref) {
  var label = _ref.label,
      value = _ref.value;

  if (value && typeof value === 'string') {
    return value;
  }

  if (get(value, 'start') && get(value, 'end') && moment(get(value, 'start')).isValid() && moment(get(value, 'end')).isValid()) {
    return "".concat(moment(get(value, 'start')).format('D MMM YY'), " - ").concat(moment(get(value, 'end')).format('D MMM YY'));
  }

  return label;
}

function PopoverInput(_ref2) {
  var _cloneElement;

  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? '' : _ref2$name,
      children = _ref2.children,
      _ref2$closeInputOnCha = _ref2.closeInputOnChange,
      closeInputOnChange = _ref2$closeInputOnCha === void 0 ? false : _ref2$closeInputOnCha,
      dataTestId = _ref2['data-testid'],
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$formatLabelText = _ref2.formatLabelText,
      formatLabelText = _ref2$formatLabelText === void 0 ? getLabelText : _ref2$formatLabelText,
      _ref2$hideActions = _ref2.hideActions,
      hideActions = _ref2$hideActions === void 0 ? false : _ref2$hideActions,
      _ref2$hideBadge = _ref2.hideBadge,
      hideBadge = _ref2$hideBadge === void 0 ? false : _ref2$hideBadge,
      _ref2$id = _ref2.id,
      id = _ref2$id === void 0 ? name : _ref2$id,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label,
      _ref2$onChange = _ref2.onChange,
      onChange = _ref2$onChange === void 0 ? identity : _ref2$onChange,
      _ref2$onChangePropsNa = _ref2.onChangePropsName,
      onChangePropsName = _ref2$onChangePropsNa === void 0 ? 'onChange' : _ref2$onChangePropsNa,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? null : _ref2$value,
      _ref2$valuePropsName = _ref2.valuePropsName,
      valuePropsName = _ref2$valuePropsName === void 0 ? 'value' : _ref2$valuePropsName;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInputOpen = _useState2[0],
      setIsInputOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      localValue = _useState4[0],
      setLocalValue = _useState4[1];

  var _useState5 = useState(label),
      _useState6 = _slicedToArray(_useState5, 2),
      labelText = _useState6[0],
      setLabelText = _useState6[1];

  var _useContext = useContext(TmsUIContext),
      setDefaultTranslations = _useContext.setDefaultTranslations,
      translate = _useContext.translate;

  useEffect(function () {
    if (isInputOpen) {
      setLocalValue(value);
    }
  }, [value, isInputOpen, setIsInputOpen, setLocalValue]);
  useEffect(function () {
    setLabelText(formatLabelText({
      label: label,
      value: value
    }));
  }, [label, value, formatLabelText]);
  var isDisabled = useMemo(function () {
    if (typeof disabled === 'function') {
      return disabled(localValue);
    }

    if (typeof disabled === 'boolean') {
      return disabled;
    }

    return false;
  }, [disabled, localValue]);
  useEffect(function () {
    setDefaultTranslations(translations);
  }, [setDefaultTranslations]);
  return /*#__PURE__*/React.createElement(Popover, {
    content: /*#__PURE__*/React.createElement(InputCard, {
      "data-testid": "".concat(dataTestId, "Content")
    }, /*#__PURE__*/React.createElement(InputCardBody, null, /*#__PURE__*/cloneElement(children, (_cloneElement = {}, _defineProperty(_cloneElement, valuePropsName, localValue), _defineProperty(_cloneElement, onChangePropsName, function (newValue) {
      setLocalValue(newValue);

      if (hideActions) {
        onChange(newValue);
      }

      if (closeInputOnChange) {
        setIsInputOpen(false);
      }
    }), _cloneElement))), hideActions ? null : /*#__PURE__*/React.createElement(React.Fragment, null, ' ', _Divider || (_Divider = /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(InputCardFooter, null, /*#__PURE__*/React.createElement(Button, {
      colorScheme: "darkGrey",
      disabled: isDisabled,
      onClick: function onClick() {
        // Cancel all changes by sending undefined value to parent component
        onChange(undefined);
        setIsInputOpen(false);
      }
    }, translate('common:clear')), /*#__PURE__*/React.createElement(Button, {
      disabled: isDisabled,
      onClick: function onClick() {
        // Commit changes by sending updated value to parent component
        onChange(localValue);
        setIsInputOpen(false);
      },
      type: "primary"
    }, translate('common:apply'))))),
    onVisibleChange: function onVisibleChange(visible) {
      if (visible) {
        setIsInputOpen(true);
        return;
      } // visible === false means user clicked on outside popover area


      setIsInputOpen(false);
      setLocalValue(value);
    },
    placement: "bottomLeft",
    trigger: "click",
    visible: isInputOpen
  }, /*#__PURE__*/React.createElement(Button, {
    colorScheme: function () {
      if ((value && !Array.isArray(value) || Array.isArray(value) && value.length > 0) && !isInputOpen) {
        return 'primary';
      }

      return isInputOpen ? 'dark' : 'darkGrey';
    }(),
    "data-testid": dataTestId,
    id: id
  }, /*#__PURE__*/React.createElement(Space, null, labelText, !hideBadge && /*#__PURE__*/React.createElement(Badge, {
    bgColor: "primary",
    count: Array.isArray(value) ? value.length : 0
  }), _DownOutlined || (_DownOutlined = /*#__PURE__*/React.createElement(DownOutlined, null)))));
}

export default PopoverInput;